import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/list.svg'
import _imports_1 from '@/assets/list-active.svg'
import _imports_2 from '@/assets/timeline.svg'
import _imports_3 from '@/assets/timeline-active.svg'


const _hoisted_1 = { class: "connected-btn" }
const _hoisted_2 = { class: "connected-btn-tooltip tooltip-main-data" }
const _hoisted_3 = ["aria-checked", "aria-disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-normal",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-active",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "tooltip-data" }
const _hoisted_8 = {
  class: "t-texts",
  title: "List View"
}
const _hoisted_9 = { class: "connected-btn-tooltip tooltip-main-data list-view-tooltip" }
const _hoisted_10 = ["aria-checked", "aria-disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-normal",
  src: _imports_2,
  alt: "Timeline icon"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-active",
  src: _imports_3,
  alt: "Timeline icon"
}, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "tooltip-data" }
const _hoisted_15 = {
  class: "t-texts",
  title: "Timeline View"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass(["list-btn", { 'active-class': !_ctx.timelineView }]),
        role: "radio",
        "aria-checked": !_ctx.timelineView ? 'true' : 'false',
        "aria-disabled": !_ctx.timelineView ? 'true' : 'false',
        "aria-label": "Organize as list",
        title: "Organize as list",
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
                    _ctx.timelineView = false;
                    _ctx.listView = true;
                })
      }, _hoisted_6, 10, _hoisted_3),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("EntityViewSelector.list_view")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        class: _normalizeClass(["list-btn", { 'active-class': _ctx.timelineView }]),
        href: "javascript:void(0)",
        role: "radio",
        "aria-checked": !_ctx.listView ? 'true' : 'false',
        "aria-disabled": !_ctx.listView ? 'true' : 'false',
        "aria-label": "Organize as timeline",
        title: "Organize as timeline",
        onClick: _cache[1] || (_cache[1] = ($event: any) => {
                    _ctx.timelineView = true;
                    _ctx.listView = false;
                })
      }, _hoisted_13, 10, _hoisted_10),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("EntityViewSelector.timeline_view")), 1)
        ])
      ])
    ])
  ]))
}